import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';

const CreateUserModal = ({ show, handleClose, handleSave, rolesMap }) => {
    const [newUser, setNewUser] = useState({
        id: '',
        nom: '',
        email: '',
        tele: '',
        role: '',
        password: ''
    });

    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewUser(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userDocRef = doc(db, 'user', newUser.id);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
            setError('ID already exists. Please choose another ID.');
            return;
        }

        try {
            await setDoc(userDocRef, newUser);
            handleSave(newUser);
            handleClose();
        } catch (error) {
            console.error("Error creating user: ", error);
            setError("Error creating user. Please try again.");
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Créer un Utilisateur</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                    <Form.Group controlId="formUserId">
                        <Form.Label>ID</Form.Label>
                        <Form.Control
                            type="text"
                            name="id"
                            value={newUser.id}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    {error && <p className="text-danger">{error}</p>}
                    <Form.Group controlId="formUserName">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            name="nom"
                            value={newUser.nom}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={newUser.email}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    </div>
                    <div className="col-md-6">
                    <Form.Group controlId="formUserTele">
                        <Form.Label>Téléphone</Form.Label>
                        <Form.Control
                            type="text"
                            name="tele"
                            value={newUser.tele}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserRole">
                        <Form.Label>Rôle</Form.Label>
                        <Form.Control
                            as="select"
                            name="role"
                            value={newUser.role}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Sélectionner un rôle</option>
                            {Object.entries(rolesMap).map(([roleId, roleName]) => (
                                <option key={roleId} value={roleId}>{roleName}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="formUserPassword">
                        <Form.Label>Mot de passe</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            value={newUser.motDePasse}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <br/>
                   
                    </div>
                    <div className="col-md-6"> 
                    <Button variant="primary" type="submit">
                        Créer
                    </Button></div>
                    </div>
                </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateUserModal;
